<template>
  <div style="position: fixed; z-index: 10000; right: 50px; bottom: 50px;">
    <transition name="fade">
      <support-form
        v-if="showForm"
        @on-submitted="toggleForm()"
        @on-close-pressed="toggleForm()"
      ></support-form>
    </transition>
    <div
      :class="['support-tab', {'support-tab-visible': minimized}]"
      @click="tabClicked()"
    >
      <support-tab></support-tab>
    </div>
    <div :class="['support-button-container', {minimized: minimized}]">
      <div class="minimize-support-button" @click="toggleMinimize()">
        <img
          src="../../assets/images/ui/icon_close.svg"
          alt=""
          srcset=""
          style="width: 100%; height: 100%;"
        />
      </div>
      <div class="support-button" @click="toggleForm()">
        <support-message-icon></support-message-icon>
      </div>
    </div>
  </div>
</template>
<script>
import SupportMessageIcon from '../../assets/icons/support-message-icon.vue';
import SupportForm from './SupportForm.vue';
import SupportTab from './SupportTab.vue';

export default {
  data() {
    return {
      showForm: false,
      minimized: false,
    };
  },
  components: {
    SupportMessageIcon,
    SupportForm,
    SupportTab,
  },
  methods: {
    toggleForm() {
      this.showForm = !this.showForm;
    },
    toggleMinimize() {
      const minimized = !this.minimized;

      if (minimized) {
        this.showForm = false;
      }

      this.minimized = !this.minimized;
    },
    tabClicked() {
      this.minimized = false;
      this.showForm = true;
    },
  },
  watch: {
    minimized: function(value) {
      localStorage.setItem('floating-button-minimize-preference', value);
    },
  },
  mounted() {
    const minimizedPreference = localStorage.getItem(
      'floating-button-minimize-preference'
    );
    this.minimized = minimizedPreference === 'true' ? true : false;
  },
};
</script>

<style scoped>
.support-button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  position: relative;
  transition: all ease-in-out 0.15s;
}

.support-button {
  height: 60px;
  width: 60px;
  background-color: white;
  padding: 12px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.15);
  background-color: #13a3eb;
  transition: all ease-in-out 0.15s;
  cursor: pointer;
}

.minimize-support-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  position: absolute;
  background-color: white;
  border-radius: 100%;
  padding: 2px;
  cursor: pointer;
  z-index: 999999;
  transform: scale(0);
  transition: all ease-in-out 0.15s;
}

.support-button-container:hover > .minimize-support-button {
  transform: scale(1);
}

.minimized {
  transform: translateX(110px);
}

.support-tab {
  right: -50px;
  position: absolute;
  bottom: 0;
  transform: translateY(-45%) translateX(25px);
  transition: all ease-in-out 0.15s;
  transition-delay: 0.15s;
  cursor: pointer;
}

.support-tab-visible {
  transform: translateY(-45%) translateX(0px);
}

/* .support-button:hover {
  transform: scale(1.1);
  transition: all ease-in-out 0.15s;
} */
</style>
